<div class="attribute-oum-container">
  <!-- <legend>Units of measurement</legend>  -->
  <div style="text-align: right; margin-bottom: 20px;">
    <button
      nz-dropdown
      [nzDropdownMenu]="menu1"
      nz-button
      nzType="primary"
      class="border-radius"
      type="button"
      style="margin-top: 5px"
    >
      {{'Insert from predefined UOMs' | translate}}
      <span nz-icon nzType="down"></span>
    </button>
  </div> 
  <div class="attribute-oum-container">
   
    <app-attribute-options
      [buttonLabel]="'Add New UOM' | translate"
      [sectionTitle]="'Units of Measurement' | translate"
      [listOfOptions]="units"
      [record]="{ Id: attributeId }"
      (optionsChanged)="handleOptionsChange($event)">
    </app-attribute-options>
  </div>
  
 <nz-dropdown-menu #menu1="nzDropdownMenu">
  <ul nz-menu>
    <li
      nz-menu-item
      *ngFor="let uom of predefinedUnits"
      (click)="addPredefinedUOMs(uom)"
    >
      {{ uom }}
    </li>
  </ul>
</nz-dropdown-menu> 







<!-- Old code -->

<!-- <div class="attribute-oum-container">
  <legend>Units of measurement</legend>
  <div style="text-align: right">
    <button
      nz-dropdown
      [nzDropdownMenu]="menu1"
      nz-button
      nzType="primary"
      class="border-radius"
      type="button"
      style="margin-top: 5px"
    >
      Insert from predefined UOMs
      <span nz-icon nzType="down"></span>
    </button>
  </div>
  <app-attribute-options
  [buttonLabel]="'Add New UOMs'"
 
  [listOfOptions]="units"
  (optionsChanged)="handleUnitsTranslationChange($event)"
></app-attribute-options> 

  <! <nz-table [nzData]="units" #unitsTable>
    <thead>
      <tr>
        <th></th>
        <th nzWidth="20%"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let unit of unitsTable.data">
        <td>{{ unit.Name }}</td>
        <td>
          <button nz-button nzDanger type="button" (click)="removeUnit(unit)">
            {{ "Remove" | locale }}
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>   -->

  <!-- <div style="text-align: center; padding: 10px">
    <button
      nz-button
      nzType="default"
      type="button"
      (click)="showAddOptionModal = true"
    >
      {{ "Add new UOM" | locale }}
    </button>
  </div> -->
</div>

<nz-dropdown-menu #menu1="nzDropdownMenu">
  <ul nz-menu>
    <li
      nz-menu-item
      *ngFor="let uom of predefinedUnits"
      (click)="addPredefinedUOMs(uom)"
    >
      {{ uom }}
    </li>
  </ul>
</nz-dropdown-menu>
<!-- 


<nz-modal [nzVisible]="showAddOptionModal" (nzOnCancel)="cancel()">
  <ng-container *nzModalTitle>{{
    "Add new unit of measurement" | locale
  }}</ng-container>
  <ng-container *nzModalContent>
    <nz-form-item nzFlex>
      <nz-form-label>UOM name</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          [(ngModel)]="optionToAdd.Name"
          id="optionToAdd"
          name="optionToAdd"
          placeholder=""
        />
      </nz-form-control>
    </nz-form-item>
  </ng-container>
  <ng-container *nzModalFooter>
    <nz-space>
      <button *nzSpaceItem nz-button nzType="primary" (click)="submitUOM()">
        {{ "Submit" | locale }}
      </button>
      <button *nzSpaceItem nz-button nzType="default" (click)="cancel()">
        {{ "Cancel" | locale }}
      </button>
    </nz-space>
  </ng-container>
</nz-modal> -->
